export const environment = {
  production: true,
  apiUrl: 'https://api.controlcar.cl',
  mpagoAppid: 7190649398030056,
  workpointUrl: 'https://workpoint.controlcar.cl',
  firebaseDatabaseUrl: 'https://kogu-production.firebaseio.com/',
  experimental: false
};
